import PropTypes from 'prop-types';
import React from 'react';
import { IMAGE_CDN_URL } from '../../utilities/imageCDN';

export const employerHeaderProps = PropTypes.shape({
    /**
     * companyName
     */
    companyId: PropTypes.number.isRequired,
    /**
     * companyName
     */
    companyName: PropTypes.string.isRequired,
    /**
     * company endpoint on website
     */
    companyURL: PropTypes.string.isRequired,
    /**
     * url for the company's official website url
     */
    originalUrl: PropTypes.shape({
        name: PropTypes.string,
        src: PropTypes.string,
    }),
    /**
     * company icon logo image info
     */
    logo: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
    /**
     * shape of company icon image
     */
    isSquare: PropTypes.bool,
    /**
     * subnav menu items
     */
    subnavMenuItems: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            url: PropTypes.string,
            counter: PropTypes.number,
            feature: PropTypes.bool,
            icon: PropTypes.bool,
            active: PropTypes.bool,
            dropdownItems: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string,
                    url: PropTypes.string,
                })
            ),
        })
    ),
    /**
     * mobile dropdown menu items
     */
    subnavMobileMenuItems: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            url: PropTypes.string,
            counter: PropTypes.number,
            feature: PropTypes.bool,
            active: PropTypes.bool,
        })
    ),
    /**
     * subnav mobile title
     */
    subnavMobileTitle: PropTypes.string,
    /**
     * banner image info
     */
    bannerImage: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
    /**
     * urls for call to action componetns
     */
    actionUrls: PropTypes.shape({
        inviteOthersUrl: PropTypes.string,
        registrationUrl: PropTypes.string,
        editAlertUrl: PropTypes.string,
        writeAReviewUrl: PropTypes.string,
        addAlertUrl: PropTypes.string,
    }),
    /**
     * whether user has alert set
     */
    userHasCompanyAlert: PropTypes.bool,
    /**
     * whether this company is a sponsor company
     */
    isSponsor: PropTypes.bool,
});

export const employerHeaderDefaultProps = {
    companyId: 1,
    companyName: 'abc',
    companyURL: '/',
    originalUrl: {
        name: 'afd',
        src: '/',
    },
    /**
     * company icon logo image info
     */
    logo: {
        src: '/',
        alt: 'F',
    },
    /**
     * shape of company icon image
     */
    isSquare: true,
    bannerImage: {
        src: `${IMAGE_CDN_URL}/v1520630626/land_banner_bg_new_lxeglq.jpg`,
        alt: 'fairygodboss background',
    },
    /**
     * subnav menu itemsgit
     */
    subnavMenuItems: [
        {
            name: '',
            url: '',
            counter: null,
            feature: false,
            icon: false,
            active: false,
            dropdownItems: [
                {
                    name: 'FSDG',
                    url: '',
                },
            ],
        },
    ],
    /**
     * mobile dropdown menu items
     */
    subnavMobileMenuItems: [
        {
            name: '',
            url: '',
            counter: null,
            feature: false,
            active: false,
        },
    ],
};
